const forms = {
  state: {
    action: null,
    actionList: null,
    actionNewDocumentList: null,
    actionListCounter: null,
    actionDID: null,
    actionRegister: null,
    actionRegisterCounter: null
  },
  mutations: {
    changeActionList(state, payload) {
      state.actionList = payload;
    },
    changeActionNewDocumentList(state, payload) {
      state.actionNewDocumentList = payload;
    },
    changeActionListCounter(state, payload) {
      state.actionListCounter = payload;
    },
    changeActionRegister(state, payload) {
      state.actionRegister = payload;
    },
    changeActionRegisterCounter(state, payload) {
      state.actionRegisterCounter = payload;
    },
    changeAction(state, payload) {
      state.action = payload;
    },
    changeActionDID(state, payload) {
      state.actionDID = payload;
    }
  },
  actions: {
    changeActionList({ commit }, payload) {
      commit("changeActionList", payload);
    },
    changeActionNewDocumentList({ commit }, payload) {
      commit("changeActionNewDocumentList", payload);
    },
    changeActionListCounter({ commit }, payload) {
      commit("changeActionListCounter", payload);
    },
    changeActionRegister({ commit }, payload) {
      commit("changeActionRegister", payload);
    },
    changeActionRegisterCounter({ commit }, payload) {
      commit("changeActionRegisterCounter", payload);
    },
    changeAction({ commit }, payload) {
      // commit to store
      commit("changeAction", payload);
    },
    changeActionDID({ commit }, payload) {
      // commit to store
      commit("changeActionDID", payload);
    }
  },
  getters: {
    getActionRegister: state => {
      return state.actionRegister;
    },
    getActionRegisterCounter: state => {
      return state.actionRegisterCounter;
    },
    getAction: state => {
      return state.action;
    },
    getActionDID: state => {
      return state.actionDID;
    },
    getActionList: state => {
      return state.actionList;
    },
    getActionNewDocumentList: state => {
      return state.actionNewDocumentList;
    },
    getActionListCounter: state => {
      return state.actionListCounter;
    }
  }
};
// eslint-disable-next-line
export default forms;
